import React from 'react';
import { User } from '../types';
import { useLanguage } from '../i18n/LanguageContext';

interface HomePageProps {
  navigate: (view: string) => void;
  user: User | null;
}

const HomePage: React.FC<HomePageProps> = ({ navigate }) => {
  const { t } = useLanguage();

  return (
    <div className="container mx-auto text-center">
      <section className="py-20 sm:py-32">
        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-stone-900 mb-6">
          {t('home.title')}
        </h1>
        <p className="max-w-2xl mx-auto text-lg md:text-xl text-stone-600 mb-10">
          {t('home.subtitle')}
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={() => navigate('the-reset')}
            className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-center text-white bg-accent rounded-full hover:bg-accent-dark focus:ring-4 focus:ring-accent/50"
          >
            {t('home.ctaButton')}
          </button>
        </div>
      </section>
    </div>
  );
};

export default HomePage;